import React from 'react'
import { data } from '../Constant/data'

const WhyLumiAds = () => {

    let whyLumiAds = data.whyLumiAds;
    return (
        <section className='why_lumi_ads' id={whyLumiAds?.id}>
            <figure className="bg_img cover">
                <img src={whyLumiAds?.decorImage?.url} alt={whyLumiAds?.decorImage?.alt} />
            </figure>
            <div className="container">
                <div className="short_cnt text_center">
                    <h2 className='text_xxl mb'>{whyLumiAds?.title?.content} <span className='text_red'>{whyLumiAds?.title?.highlight}</span></h2>
                    <p className='text_md'>{whyLumiAds?.description}</p>
                </div>
                <figure className='middle'>
                    <img src={whyLumiAds?.image?.url} alt={whyLumiAds?.image?.alt} className='icon' />
                </figure>
                <ul className='features_list'>
                    {whyLumiAds?.features?.map((el, index) => {
                        return (
                            <li key={index}>
                                <div className="text_center">
                                    <span className='icon_img'><img src={el?.image?.url} alt={el?.image?.alt} className='icon' /></span>
                                    <h3 className='text_lg mb'>{el?.title}</h3>
                                </div>
                                <p className='justify'>{el?.description}</p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}

export default WhyLumiAds